import { Model, RailsFormat } from "./model";
import { Contact } from "./contact";
import { Timeslot } from "./timeslot";
import * as moment from "moment";

interface TimeslotsByTutor {
  contact?: Contact,
  timeslots?: Timeslot[]
}

export class TutorTimeslots extends Model {

  constructor(
    public date: Date = null,
    public byTutor: TimeslotsByTutor[] = null,
  ) { super() }

  static clone(obj: any) {
    const t = new this()

    if (obj.date) { t.date = new Date(obj.date) }
    if (obj.byTutor && obj.byTutor.length > 0) {

      t.byTutor = obj.byTutor.map((bt: any) => {
        const timeslotsByTutor: TimeslotsByTutor = {}

        if (bt.contact) {
          timeslotsByTutor.contact = Contact.clone(bt.contact)
        }

        if (bt.timeslots && bt.timeslots.length > 0) {
          timeslotsByTutor.timeslots =
            bt.timeslots.map((t: any) => Timeslot.clone(t))
        }

        return timeslotsByTutor
      })

    }

    return t
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/tutor-timeslots.ts